(function () {
  'use strict';
  if (window.ceCollectionBooted) return;
  window.ceCollectionBooted = true;
  function update() {
    document.querySelectorAll('[data-ce-collection]').forEach(function (root) {
      var mode = root.dataset.occasion === 'auto' ? document.documentElement.dataset.ceTheme : root.dataset.occasion;
      mode = mode === 'newyear' ? 'newyear' : 'christmas';
      var view = mode === 'newyear' ? 'revelion' : 'craciun';
      var name = mode === 'newyear' ? 'Revelion' : 'Crăciun';
      var closeAt = mode === 'newyear' ? root.dataset.newyearClose : root.dataset.christmasClose;
      var delivery = mode === 'newyear' ? root.dataset.newyearDelivery : root.dataset.christmasDelivery;
      var deadline = mode === 'newyear' ? root.dataset.newyearDeadline : root.dataset.christmasDeadline;
      root.querySelectorAll('[data-ce-c-occasion]').forEach(function (e) {e.textContent = name;});
      root.querySelectorAll('[data-ce-c-delivery]').forEach(function (e) {e.textContent = delivery;});
      var closed = Number.isFinite(Date.parse(closeAt)) && Date.now() >= Date.parse(closeAt);
      root.querySelectorAll('[data-ce-c-deadline]').forEach(function (e) {e.textContent = closed ? 'Precomenzile de ' + name + ' sunt închise.' : deadline;});
      root.querySelectorAll('[data-ce-c-view]').forEach(function (e) {e.value = view;});
      root.querySelectorAll('[data-ce-c-link]').forEach(function (a) {
        var url = new URL(a.href, location.href);
        if (url.origin !== location.origin) return;
        url.searchParams.set('view', view);
        a.href = url.pathname + url.search + url.hash;
      });
    });
  }
  document.addEventListener('ce:theme-change', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.ce-c-filters[open]').forEach(function (details) {details.open=false;details.querySelector('summary').focus();});
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.ce-c-filters[open]').forEach(function (details) {if (!details.contains(e.target)) details.open=false;});
  });
  update();
  setInterval(update, 30000);
})();
